module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VG1007-b73ea096403eb8bea3c485107edc8e58.png";